import React, { Component } from 'react';
import { UnauthRoute as AnonymousRoute, AuthRoute as Route } from 'react-router-auth';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import asyncComponent from '../../components/AsyncComponent';
import Nav from '../../components/Nav';
import MobileNavigation from '../../components/MobileNavigation';
import { setCurrentUser } from '../Login/actions';

const AsyncOrders = asyncComponent(() => import('../Orders'));
const AsyncLogin = asyncComponent(() => import('../Login'));
const AsyncChat = asyncComponent(() => import('../Chat'));
const AsyncAuthCallback = asyncComponent(() => import('../AuthCallback'));
const AsyncResetPassword = asyncComponent(() => import('../ResetPassword'));
const AsyncFirstLogin = asyncComponent(() => import('../FirstLogin'));
const AsyncSetPassword = asyncComponent(() => import('../SetPassword'));

const lazyRoutes = [
  AsyncOrders, AsyncLogin, AsyncChat, AsyncAuthCallback,
  AsyncResetPassword, AsyncFirstLogin, AsyncSetPassword,
];

const shouldPreloadRoutes = () => {
  const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (!conn) return true;
  if (conn.saveData) return false;
  return !/(^|-)2g$/.test(conn.effectiveType || '');
};

class App extends Component {
  componentDidMount() {
    if (!shouldPreloadRoutes()) return;
    const preload = () => lazyRoutes.forEach(c => c.preload && c.preload().catch(() => {}));
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(preload, { timeout: 5000 });
    } else {
      setTimeout(preload, 2000);
    }
  }

  logout = () => {
    const { history, setUser } = this.props;
    setUser(null);
    history.push('/login');
  }

  isAuthenticated = () => {
    const { auth: { user } } = this.props;
    if (!user) return false;
    if (!user.expiresAt) return false;
    return new Date().getTime() < user.expiresAt;
  }

  render() {
    const { location } = this.props;
    const hideNav = location.pathname === '/login'
      || location.pathname === '/reset-password'
      || location.pathname === '/first-login'
      || location.pathname === '/set-password'
      || location.pathname === '/auth/callback';
    return (
      <div>
        {!hideNav && this.isAuthenticated() && <Nav logout={this.logout} />}
        <AnonymousRoute
          exact
          path='/login'
          component={AsyncLogin}
          redirectTo='/'
          authenticated={this.isAuthenticated()}
        />
        <AnonymousRoute
          exact
          path='/reset-password'
          component={AsyncResetPassword}
          redirectTo='/'
          authenticated={this.isAuthenticated()}
        />
        <AnonymousRoute
          exact
          path='/first-login'
          component={AsyncFirstLogin}
        />
        <AnonymousRoute
          exact
          path='/set-password'
          component={AsyncSetPassword}
        />
        <AnonymousRoute
          exact
          path='/auth/callback'
          component={AsyncAuthCallback}
          redirectTo='/'
          authenticated={this.isAuthenticated()}
        />
        <Route
          exact
          path='/'
          component={AsyncOrders}
          redirectTo='/login'
          authenticated={this.isAuthenticated()}
        />
        <Route
          exact
          path='/history'
          component={() => <AsyncOrders isHistory />}
          redirectTo='/login'
          authenticated={this.isAuthenticated()}
        />
        <Route
          exact
          path='/chat/:id'
          component={AsyncChat}
          redirectTo='/login'
          authenticated={this.isAuthenticated()}
        />
        <div className='spacer' />
        {!hideNav && this.isAuthenticated() && <MobileNavigation />}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

const mapDispatchToProps = dispatch => ({
  setUser: user => dispatch(setCurrentUser(user)),
});

App = connect(mapStateToProps, mapDispatchToProps)(App);

export default withRouter(App);
